import SettingsGroupManagement from './SettingsGroupManagement'

export default SettingsGroupManagement
